import React, { Component } from 'react'
//import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {storesTicketsLiveTableReady,rowsPerPageState,searchTextState,paginationState,storesTicketIdForAction} from '../redux/stores'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/storeTable.css'


import {Kitchens,Cities} from '../../../common/DropDowns/index'

import {StoresComboList} from './DropDowns/index'





function filterUnwantedData(storesTicketsLiveData) {
    let array = []
    if (storesTicketsLiveData && storesTicketsLiveData.data && storesTicketsLiveData.data.list) {
        array = storesTicketsLiveData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.store_name =  lineData.store.name ? lineData.store.name : "NA"
            newLineData.urbanpiper_id =  lineData.store.urbanpiper_id ? lineData.store.urbanpiper_id : "NA"
            newLineData.kitchen_name =  lineData.store.kitchen && lineData.store.kitchen.name ? lineData.store.kitchen.name : "NA"
            newLineData.contact_no =  lineData.store.kitchen && lineData.store.kitchen.contact_no ? lineData.store.kitchen.contact_no : "NA"
            newLineData.platform_name =lineData.platform_name ? lineData.platform_name : "NA"
            newLineData.type =lineData.type ? lineData.type : "NA"
            newLineData.status =lineData.status ? lineData.status : "NA"
            newLineData.created =lineData.created ? lineData.created : "NA"
            newLineData.modified =lineData.modified ? lineData.modified : "NA"
            newLineData.remarks =lineData.remarks ? lineData.remarks : "NA"
            newLineData.hold_till =lineData.hold_till

            newLineData.reason="NA"
            if(lineData.reason && lineData.reason.name){
                newLineData.reason=lineData.reason.name ? lineData.reason.name : "NA"
            }

            newArray[i] = newLineData
        }
    }
    return newArray
}


class StoresTicketsLiveTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            storesTicketsLiveData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_store_id:"",
            filter_kitchen_id:"",
            filter_city_id:"",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(storesTicketsLiveTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.STORES_TICKETS_LIVE_TABLE)) 
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoresTicketsData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }

      renderReasonRemarks = (cell, row, enumObject, rowIndex,) => {
        
        let reason=""
        
            reason=<p>{row.reason}<br/>({row.remarks})</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{reason}</div>
        </div>)
    }

    
    getStoresTicketsData = () => {
        apiService.getStoresTicketsLiveData(this.state.filter_kitchen_id,this.state.filter_store_id,this.state.filter_city_id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.stores && this.props.stores.previousPaginationValue) {
                            pageNo = this.props.stores.previousPaginationValue
                        }
                        this.setState({
                            storesTicketsLiveData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(storesTicketsLiveTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(storesTicketsLiveTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }


kitchenChange = (data) => {

        this.setState({
            filter_kitchen_id :data.value,
            
        })
    }
    cityChange = (data) => {

        this.setState({
            filter_city_id :data.value,
            
        })
    }
    storeChange = (data) => {

        this.setState({
            storeSelectedId :data.value,
            
        })
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.stores && this.props.stores.previousRowsPerPageValue) {
            value = this.props.stores.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }


    kitchenChange = (data) => {

        this.setState({
            filter_kitchen_id :data.value,
            
        })
    }


    createCustomToolBar = props => {

            return (

            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                    
                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                     <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                            <a href="" 
                                onClick={(e) => {e.preventDefault() 
                                            this.props.history.goBack()}}> 
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                            </a>
                        </div>
                    </div>



                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <Cities cityChange={this.cityChange} selectedValue={this.state.filter_city_id} />   
                    </div>
                    </div>

                     {(() => {
                        if(this.state.filter_city_id && this.state.filter_city_id!=="" && this.state.filter_city_id!==undefined){
                            return(
                           <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                            <div className="form-group">
                                <Kitchens kitchenChange={this.kitchenChange} selectedCity={this.state.filter_city_id} selectedValue={this.state.filter_kitchen_id} />   
                            </div>
                            </div>
                            )
                        }
                    })()}

                    {(() => {
                        if(this.state.filter_kitchen_id && this.state.filter_kitchen_id!=="" && this.state.filter_kitchen_id!==undefined){
                            return(

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <StoresComboList storeChange={this.storeChange} selectedKitchen={this.state.filter_kitchen_id} selectedValue={this.state.storeSelectedId} />    
                    </div>
                    </div>
                    )
                        }
                    })()}

                     <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredLiveStoresList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                    

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return (
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 footer-pagination-icons">
                    {props.components.pageList}
                </div>
            </div>
        )
    }

    getFilteredLiveStoresList = () => {
       
        this.props.dispatch(storesTicketsLiveTableReady(false))
        this.resetSearchAndPagination()
        this.getStoresTicketsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }



    
    resetFilterValues = () => {
        this.resetPagination()
        this.getStoresTicketsData()
        this.props.dispatch(storesTicketsLiveTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    resetFilterValues = () => {
        this.props.dispatch(storesTicketsLiveTableReady(false))
        this.setState({
            filter_kitchen_id:"",
            filter_city_id:"",
            filter_store_id:""
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.getStoresTicketsData();
        });

       

        
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =
        
            <button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editStore(row)
                }}>
                Edit
            </button>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.stores && this.props.stores.previousPaginationValue
            && this.props.stores.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }


renderCreatedDateFormat = (cell, row, enumObject, rowIndex,) => {
        //debugger;
        

        let dateTemp="NA"

        if(row.created){
            dateTemp=Helpers.getDateTimeFormatForUTC(row.created)
        }
        
         
        return (<p>{dateTemp}</p>)
    }

    renderStatusFormat = (cell, row, enumObject, rowIndex,) => {
        
        let statusTemp=row.status

        if(row.status==="HOLD"){
            statusTemp=<p>{row.status}<br/>{Helpers.getDateTimeFormatForUTC(row.hold_till)}</p>
        }

        if(row.status==="CLOSED"){
            statusTemp=<p>{row.status}<br/>{Helpers.getDateTimeFormatForUTC(row.modified)}</p>
        }

        return (<div className={"row ticket_status_"+row.status+""}>
            <div className="col-md-12 col-sm-12 col-xs-12">{statusTemp}</div>
        </div>)
    }





     addBtnCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        

        let addBtn=""

        if(row.status==="NEW" || row.status==="HOLD"){
            addBtn =<button
                className="action-button"
                style={{marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editStoreTicket(row)
                }}>
                <i className="fa fa-clock-o" aria-hidden="true"></i> Edit
            </button>
        }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{addBtn} </div>
        </div>)
    }

editStoreTicket= (row) =>{

    if (row && row.id) {
            this.props.dispatch(storesTicketIdForAction(row.id))
            this.props.history.push("/dashboard/storestickets/edit")
        } else {
            this.dialog.show({
                title: "Store Identification number not found",
                body: 'Store id is not available, So not able edit store',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    
}






    

    render() {
        let sizeperPage = 15

        if (this.props.stores && this.props.stores.previousRowsPerPageValue) {
            sizeperPage = this.props.stores.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
           sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (


            <div className="storesTicketslive-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>                

                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.storesTicketsLiveData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    >

                    

                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="urbanpiper_id"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Urbanpiper Id
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="kitchen_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Kitchen
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="store_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Store
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataField="contact_no"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Contact
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="platform_name"                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Platform
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="type"
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Type
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataFormat={this.renderStatusFormat}
                         dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        //dataField="reason"
                        dataFormat={this.renderReasonRemarks}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Reason
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataFormat={this.renderCreatedDateFormat}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Created on
                    </TableHeaderColumn>


                     <TableHeaderColumn
                        expandable={false}
                        dataFormat={this.addBtnCreator}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>    

                
                </BootstrapTable>
            </div>


        )



    }

}



const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        stores: state.stores
    }
}

export default connect(mapStateToProps)(withRouter(StoresTicketsLiveTable))


// WEBPACK FOOTER //
// ./src/modules/Stores/Components/StoresTicketsLiveTable.js